var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"target"},[_c('transition',{attrs:{"appear":!_vm.onScroll},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter}},[_c('div',{directives:[{name:"visible",rawName:"v-visible",value:(!_vm.onScroll || _vm.animate),expression:"!onScroll || animate"}],ref:"container"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }